export default "__VITE_ASSET__CsGXG$tA__"